interface BreadCrumbItem {
  id: string
  label: string
  path: string
}

/*
 * The path parts that have valid translations. E.g.
 * `/my-hos/machinery/G2000` = ['my-hos', 'machinery', 'G2000']
 *
 * Add new translations inside the locales files, using the prefix:
 * `customerModule.breadcrumb.PATH` (e.g. `customerModule.breadcrumb.my-hos`)
 */
const breadcrumbsToTranslate = ['my-hos', 'rental', 'profile', 'machinery', 'foreign-machinery', 'active', 'completed', 'sale', 'special', 'manage', 'service-project', 'shop', 'booking', 'buy', 'rent', 'quick-sale']

export default () => {
  const route = useRoute()
  const splitPath = computed(() => route.path.split('/'))

  const { $i18n } = useNuxtApp()
  function formatRouteLabel(path: string) {
    if (!breadcrumbsToTranslate.includes(path)) {
      return path
    }

    // Here we check if the route has been translated. If not we just return the last part of the path.
    const translatedLabel = $i18n.t(`customerModule.breadcrumb.${path}`)
    if (translatedLabel.startsWith('customerModule.breadcrumb.')) {
      return path
    }
    return translatedLabel
  }

  const breadcrumbs = computed(() => {
    let path: string | undefined
    const breadcrumbs: BreadCrumbItem[] = []

    splitPath.value.forEach((item, index) => {
      if (index === 0) {
        return
      }
      if (path) {
        path = `${path}/${item}`
      } else {
        path = `${item}`
      }

      breadcrumbs.push({
        id: item,
        label: formatRouteLabel(item),
        path: `/${path}`,
      })
    })

    return breadcrumbs
  })

  return breadcrumbs
}
